// extracted by mini-css-extract-plugin
module.exports = {"base":"useModalWorkspaceAddMember_base__2LwKZ","label":"useModalWorkspaceAddMember_label__nOfWf"};